import { render, staticRenderFns } from "./SurveyChatsPage.vue?vue&type=template&id=6f461d10"
import script from "./SurveyChatsPage.vue?vue&type=script&lang=js"
export * from "./SurveyChatsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports